import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'kett-dialog-comment',
  templateUrl: './dialog-comment.component.html',
  styleUrls: ['./dialog-comment.component.scss'],
})
export class DialogCommentComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<DialogCommentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  tnt_vote_result = 'Excellent';
  tnt_reason = '';
  tnt_rating = 5;
  rating: number = 5;
  starCount: number = 5;
  tnt_performance:string='Fast';
  ratingArr: number[] = [];

  ngOnInit() {
    for (let index = 0; index < this.starCount; index++) {
      this.ratingArr.push(index);
    }
  }
  onClick(rating: number) {
    this.tnt_rating = rating;
  }

  showIcon(index: number) {
    if (this.rating >= index + 1) {
      return 'star';
    } else {
      return 'star_border';
    }
  }

  Back(res: boolean) {
    if (res)
      this.dialogRef.close({
        tnt_rating: this.tnt_rating,
        tnt_reason: this.tnt_reason.trim(),
        tnt_vote_result: this.tnt_vote_result,
        tnt_performance:this.tnt_performance,
        timestamp: '',
      } as Comments_Model);
    else this.dialogRef.close(undefined);
  }
}

export interface Comments_Model {
  tnt_rating: number;
  tnt_vote_result: string;
  tnt_reason: string;
  tnt_performance:string;
}
